export class BudgetControl {
  el: JQuery;
  private hasMonthly: boolean;
  private numberOfMonths: number;
  private fractionDigits: number;

  constructor(private id: string, private nextSequence: number) {
    const me = this;
    this.el = $('#' + this.id);
    this.hasMonthly = this.el.find('tr[data-monthly]').length > 0;
    this.numberOfMonths = Number(this.el.data('number-of-months')) || 12;
    const fractionDigits = Number(this.el.data('fraction-digits'));
    this.fractionDigits = isNaN(fractionDigits) ? 2 : fractionDigits;

    $('#BudgetNumberOfMonths').on('input', function () {
      const value = Number($(this).val());
      if (value > 0) {
        me.numberOfMonths = value;
        me.recalculateAllMonthlyRows();
      }
    });

    this.el
      .on('keyup', '.currency:not(.monthly)', function () {
        if (me.hasMonthly) {
          const row$ = $(this).closest('tr');
          if (row$.is('[data-monthly]')) {
            me.syncYearlyToMonthly(row$);
          }
        }
        me.update();
      })
      .on('keyup', '.monthly', function () {
        const row$ = $(this).closest('tr');
        me.syncMonthlyToYearly(row$);
        me.update();
      })
      .on('blur', '.currency:not(.monthly)', function (e) {
        const value = me.getNumber($(e.currentTarget).val());
        if (isNaN(value)) {
          return;
        }
        const n = value.toFixed(me.fractionDigits);
        $(e.currentTarget).val(me.numberToString(+n));
        if (me.hasMonthly) {
          const row$ = $(e.currentTarget).closest('tr');
          if (row$.is('[data-monthly]')) {
            me.syncYearlyToMonthly(row$);
          }
        }
        me.update();
      })
      .on('blur', '.monthly', function (e) {
        const value = me.getNumber($(e.currentTarget).val());
        if (isNaN(value)) {
          return;
        }
        const n = value.toFixed(me.fractionDigits);
        $(e.currentTarget).val(me.numberToString(+n));
        const row$ = $(e.currentTarget).closest('tr');
        me.syncMonthlyToYearly(row$);
        me.update();
      })
      .on('click', '.add-row', function (e) {
        e.preventDefault();
        me.addOrRemoveRow($(e.currentTarget));
        me.update();
      });

    this.sizeColumns();

    $(document).on('globalizeLoadReady', () => {
      this.el.removeAttr('inert');
      this.update();
    });
  }

  sizeColumns(): void {
    const cols$ = this.el.find('td[data-width]');
    cols$.each((_, col) => {
      const col$ = $(col);
      const index = col$.index() + 1;
      const width = Number(col$.data('width'));
      if (width) {
        col$.css('width', `${width}%`);
      } else if (index > 0) {
        this.el.find(`td:nth-child(${index}), th:nth-child(${index})`).hide();
      }
    });
  }

  update(): void {
    const totalIncome = this.sum('.income');
    const totalCost = this.sum('.cost');
    this.el.find('.subtotal-income').val(this.numberToString(totalIncome));
    this.el.find('.subtotal-cost').val(this.numberToString(totalCost));
    this.el.find('.total').val(this.numberToString(totalIncome - totalCost));

    this.updatePercentages(totalIncome, 'income');
    this.updatePercentages(totalCost, 'cost');
  };

  updatePercentages(subTotal: number, type: string): void {
    const rows$ = this.el.find(`tr[data-type='${type}']`);
    rows$.each((_, row) => {
      const row$ = $(row);
      const amount$ = row$.find('.amount input');
      const value = this.getNumber(amount$.val());
      if (isNaN(value)) {
        return;
      }
      const percentage = subTotal > 0 ? Math.round(value / subTotal * 100).toFixed(0) : 0;
      row$.find('.percentage').text(`${percentage}%`);
    });
  }

  sum(selector: string): number {
    let sum = 0;
    const me = this;

    this.el.find(selector).each(function (_, x) {
      const value = me.getNumber($(x).val());
      if (isNaN(value)) {
        return;
      }
      sum += isNaN(value) ? 0 : value;
    });
    return sum;
  };

  getNumber(value: any): number {
    return window.Globalize.numberParser()(value?.toString());
  }

  numberToString(value: number): string {
    return window.Globalize.numberFormatter({ minimumFractionDigits: this.fractionDigits, maximumFractionDigits: this.fractionDigits })(value);
  }

  syncMonthlyToYearly(row$: JQuery): void {
    const monthly$ = row$.find('.monthly');
    const amount$ = row$.find('.amount input');
    const monthlyValue = this.getNumber(monthly$.val());
    if (!isNaN(monthlyValue)) {
      const yearly = +(monthlyValue * this.numberOfMonths).toFixed(this.fractionDigits);
      amount$.val(this.numberToString(yearly));
    } else {
      amount$.val('');
    }
  }

  syncYearlyToMonthly(row$: JQuery): void {
    const monthly$ = row$.find('.monthly');
    const amount$ = row$.find('.amount input');
    const yearlyValue = this.getNumber(amount$.val());
    if (!isNaN(yearlyValue)) {
      const monthly = +(yearlyValue / this.numberOfMonths).toFixed(this.fractionDigits);
      monthly$.val(this.numberToString(monthly));
    } else {
      monthly$.val('');
    }
  }

  recalculateAllMonthlyRows(): void {
    const me = this;
    this.el.find('tr[data-monthly]').each(function () {
      me.syncMonthlyToYearly($(this));
    });
    this.update();
  }

  addOrRemoveRow(button: JQuery): void {
    if (button.hasClass('btn-danger')) {
      button.closest('tr').remove();
    } else {
      const rowsOfName = this.el.find('tr[data-name=\'' + button.data('name') + '\']');
      if (rowsOfName.length >= button.data('max-lines')) {
        alert(window.ifunds.strings.maximumNumberOfLinesReached);
        return;
      }
      const newRow = $(button.closest('tr').get(0).outerHTML.replace(/_\d+/g, '_' + this.nextSequence++));
      newRow.find('button').removeClass('btn-success').addClass('btn-danger').find('i').attr('class', 'fas fa-remove');
      newRow.find('input.budget-caption').prop('readonly', false).val('');
      newRow.find('th, textarea').text('');
      newRow.find('.currency').val('0');
      newRow.find('.download').remove();
      newRow.insertAfter(rowsOfName.last());
      newRow.find('input:first').focus();
    }
    const form = this.el.closest('form');
    form.data('validationManager').init();
  };
}
